import React, { useState, useEffect } from "react";
import { initializeApp } from "firebase/app";
import {
  getDatabase,
  ref,
  set,
  push,
  get,
  serverTimestamp,
  onValue,
  query,
  orderByChild,
} from "firebase/database";
import { Link } from "react-router-dom";

function Podcasts() {
  const [podcasts, setPodcasts] = useState([]);

  const firebaseConfig = {
    apiKey: "AIzaSyB7D3p41RmiAOp_cbFJB2pUPb9a33J4IPI",
    authDomain: "aipodcastmania.firebaseapp.com",
    databaseURL: "https://aipodcastmania-default-rtdb.firebaseio.com",
    projectId: "aipodcastmania",
    storageBucket: "aipodcastmania.appspot.com",
    messagingSenderId: "514246671749",
    appId: "1:514246671749:web:7cf93b54e798c8be8d58ec",
    measurementId: "G-XKJ38EFBKN",
  };

  const app = initializeApp(firebaseConfig);
  const db = getDatabase(app);

  useEffect(() => {
    const podcastRef = ref(db, "podcasts");
    const recentSearches = query(podcastRef, orderByChild("timestamp"));

    onValue(recentSearches, (snapshot) => {
      const recentSearchesObject = [];
      snapshot.forEach((childSnapshot) => {
        const childKey = childSnapshot.key;
        const childData = childSnapshot.val();
        if (childData.result) recentSearchesObject.push([childKey, childData]);
      });

      recentSearchesObject.reverse();

      // reverse the array so the most recent podcast is first

      setPodcasts([...recentSearchesObject]);
    });
  }, []);

  return (
    <div className="flex flex-col items-center justify-center">
      <h1 className="text-4xl text-pink-300 mt-16 mb-8 font-bold text-center">
        Podcasts
      </h1>
      <div
        style={{
          width: "90%",
          height: "60vh",
        }}
        className="flex flex-row flex-shrink flex-wrap overflow-y-auto"
      >
        {podcasts.map((podcast) => (
          <div
            style={{
              fontSize: "20px",
            }}
            className="text-pink-300 overflow-y-auto bg-slate-600 rounded-xl px-2 my-1 mx-2 text-black font-bold"
          >
            <Link to={`/podcast/${podcast[0]}`}>
              {podcast[1].prompt.length > 50
                ? podcast[1].prompt.substring(0, 50).trim() + "..."
                : podcast[1].prompt}
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Podcasts;
